/** Default funnel data table columns (steps 2+). At least one of conversionFromPrevious or stepCount must stay true. */
export const DEFAULT_FUNNEL_TABLE_COLUMNS = {
  conversionFromFirst: false,
  conversionFromPrevious: true,
  stepCount: true,
  avgTimeFromFirst: false,
  avgTimeFromPrevious: false,
};
